import React from "react";
import styled from "styled-components";
import { Provider } from "react-redux";

import store from "./data/redux/store";
import connect from "./data/redux/connect";

import WordSearch from "./components/WordSearch";
import Result from "./components/Result";

const mapResults = words =>
  words.map((word, i) => <Result word={word} key={i} />);

const SearchContainer = styled.div`
  position: relative;
  height: 100px;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 20px;
`;

const ResultsContainer = styled.div`
  position: relative;
  background-color: $color-white;
  width: 100%;
  height: calc(100% - 100px);
  overflow: auto;
  padding: 0 20px 20px 20px;
  display: block;
  margin: 0 auto;
  z-index: 1;
`;

const Vocabularium = props => {
  const { dictionary } = props;
  return (
    <div>
      <SearchContainer>
        <WordSearch />
      </SearchContainer>
      <ResultsContainer>{mapResults(dictionary)}</ResultsContainer>
    </div>
  );
};

const ConnectedVocabularium = connect(Vocabularium);

export default () => (
  <Provider store={store}>
    <ConnectedVocabularium />
  </Provider>
);



// WEBPACK FOOTER //
// ./src/apps/vocabularium/index.js